export default __webpack_public_path__ + "static/media/shared_folder.c1efa645.svg";